<!-- Mes -->
@if (mostrar()) {
  <mat-form-field style="margin-bottom: 1em">
    <mat-label>Mes</mat-label>
    <input
      matInput
      [matDatepicker]="dp"
      [(ngModel)]="mes"
      (click)="dp.open()"
    />
    <mat-hint>MM/YYYY</mat-hint>
    <mat-datepicker-toggle matSuffix [for]="dp" />
    <mat-datepicker
      #dp
      startView="multi-year"
      (monthSelected)="setMonthAndYear($event, dp)"
    />
  </mat-form-field>
}
